var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophygreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 0H6.1875C5.25586 0 4.49648 0.766406 4.53164 1.69453C4.53867 1.88086 4.5457 2.06719 4.55625 2.25H0.84375C0.376172 2.25 0 2.62617 0 3.09375C0 6.34922 1.17773 8.61328 2.75977 10.1496C4.31719 11.6648 6.21563 12.4277 7.61484 12.8145C8.4375 13.043 9 13.7285 9 14.4176C9 15.1523 8.40234 15.75 7.66758 15.75H6.75C6.12773 15.75 5.625 16.2527 5.625 16.875C5.625 17.4973 6.12773 18 6.75 18H13.5C14.1223 18 14.625 17.4973 14.625 16.875C14.625 16.2527 14.1223 15.75 13.5 15.75H12.5824C11.8477 15.75 11.25 15.1523 11.25 14.4176C11.25 13.7285 11.809 13.0395 12.6352 12.8145C14.0379 12.4277 15.9363 11.6648 17.4938 10.1496C19.0723 8.61328 20.25 6.34922 20.25 3.09375C20.25 2.62617 19.8738 2.25 19.4062 2.25H15.6937C15.7043 2.06719 15.7113 1.88438 15.7184 1.69453C15.7535 0.766406 14.9941 0 14.0625 0ZM1.71914 3.9375H4.68633C5.00625 7.10508 5.71289 9.22148 6.51094 10.6383C5.63555 10.2516 4.725 9.70664 3.9375 8.94023C2.8125 7.84688 1.89844 6.26836 1.72266 3.9375H1.71914ZM16.316 8.94023C15.5285 9.70664 14.618 10.2516 13.7426 10.6383C14.5406 9.22148 15.2473 7.10508 15.5672 3.9375H18.5344C18.3551 6.26836 17.441 7.84688 16.3195 8.94023H16.316Z",
    fill: "#6BBF59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophygreen);
export default __webpack_public_path__ + "static/media/trophy green.ffca4db781d1ed637657bb0cd5555141.svg";
export { ForwardRef as ReactComponent };